import * as types from '../constants'

import Api from '../services/api.js'
import history from '../history'
import {refreshUser} from './app_token'

export function createNewPlanRequest(){
  return {
    type: types.CREATE_NEW_PLAN_REQUEST,
  }
}

export function createNewPlanSuccess(body){
  return {
    type: types.CREATE_NEW_PLAN_SUCCESS,
    body: body
  }
}

export function createNewPlanFailure(exception){
  return {
    type: types.CREATE_NEW_PLAN_FAILURE,
    exception: exception
  }
}

export function updatePlanRequest(){
  return {
    type: types.UPDATE_PLAN_REQUEST,
  }
}

export function updatePlanSuccess(body){
  return {
    type: types.UPDATE_PLAN_SUCCESS,
    body: body
  }
}

export function updatePlanFailure(exception){
  return {
    type: types.UPDATE_PLAN_FAILURE,
    exception: exception
  }
}

export function deletePlanRequest(planId){
  return {
    type: types.DELETE_PLAN_REQUEST,
    planId
  }
}

export function deletePlanSuccess(body, isTemplate){
  return {
    type: types.DELETE_PLAN_SUCCESS,
    body: body,
    isTemplate: isTemplate
  }
}

export function deletePlanFailure(planId, exception){
  return {
    type: types.DELETE_PLAN_FAILURE,
    exception: exception,
    planId
  }
}

export function clearPlan(){
  return {
    type: types.CLEAR_PLAN
  }
}

export function getPlansRequest(body){
  return {
    type: types.GET_PLANS_REQUEST
  }
}

export function getPlansSuccess(body, isTemplate){
  return {
    type: types.GET_PLANS_SUCCESS,
    body: body,
    isTemplate: isTemplate
  }
}

export function getPlansFailure(body){
  return {
    type: types.GET_PLANS_FAILURE
  }
}

export function loadPlanRequest(){
  return {
    type: types.LOAD_PLAN_REQUEST,
  }
}

export function loadPlanSuccess(body){
  return {
    type: types.LOAD_PLAN_SUCCESS,
    body: body
  }
}

export function loadPlanFailure(exception){
  return {
    type: types.LOAD_PLAN_FAILURE,
    exception: exception
  }
}

export function exportPlanToExcelRequest(){
  return {
    type: types.EXPORT_PLAN_TO_EXCEL_REQUEST,
  }
}

export function exportPlanToExcelSuccess(body){
  return {
    type: types.EXPORT_PLAN_TO_EXCEL_SUCCESS,
    body: body
  }
}

export function exportPlanToExcelFailure(exception){
  return {
    type: types.EXPORT_PLAN_TO_EXCEL_FAILURE,
    exception: exception
  }
}

export function getComparisonsRequest(){
  return {
    type: types.GET_COMPARISONS_REQUEST,
  }
}

export function getComparisonsSuccess(body){
  return {
    type: types.GET_COMPARISONS_SUCCESS,
    body: body
  }
}

export function getComparisonsFailure(exception){
  return {
    type: types.GET_COMPARISONS_FAILURE,
    exception: exception
  }
}

export function getProfileRequest(){
  return {
    type: types.GET_PROFILE_REQUEST,
  }
}

export function getProfileSuccess(body){
  return {
    type: types.GET_PROFILE_SUCCESS,
    body: body
  }
}

export function getProfileFailure(exception){
  return {
    type: types.GET_PROFILE_FAILURE,
    exception: exception
  }
}

export function getTreeRequest(){
  return {
    type: types.GET_TREE_REQUEST,
  }
}

export function getTreeSuccess(body){
  return {
    type: types.GET_TREE_SUCCESS,
    body: body
  }
}

export function getTreeFailure(exception){
  return {
    type: types.GET_TREE_FAILURE,
    exception: exception
  }
}

export function getPlanTagsRequest(){
  return {
    type: types.GET_PLAN_TAGS_REQUEST,
  }
}

export function getPlanTagsSuccess(body){
  return {
    type: types.GET_PLAN_TAGS_SUCCESS,
    body: body
  }
}

export function getPlanTagsFailure(exception){
  return {
    type: types.GET_PLAN_TAGS_FAILURE,
    exception: exception
  }
}

export function createNewPlan(params) {

  return dispatch => {
    dispatch(createNewPlanRequest())
    const api = new Api();
    return api.createNewPlan("/__api/v1/plan", params)
    .then(response => {
      Promise.all([
        dispatch(createNewPlanSuccess(response.data.plan)),
        dispatch(refreshUser(response.data.current_user))
      ]).then(() => {
        openPlanPage(response.data.plan, true);
      });
    })
    .catch(err => dispatch(createNewPlanFailure(err)));
  }
}

export function updatePlan(plan) {
  return dispatch => {
    dispatch(updatePlanRequest())
    const api = new Api();
    return api.updatePlan("/__api/v1/plan/" + plan.id, plan)
    .then(response => {
      dispatch(updatePlanSuccess(response.data))
    })
    .catch(err => dispatch(updatePlanFailure(err)));
  }
}

export function deletePlan(plan_id, isTemplate) {
  return dispatch => {
    dispatch(deletePlanRequest(plan_id))
    const api = new Api();
    return api.delete("/__api/v1/plan/" + plan_id, null)
    .then(response => {
      dispatch(deletePlanSuccess(response.data, isTemplate))
    })
    .catch(err => dispatch(deletePlanFailure(plan_id, err)));
  }
}

const getPlansApi = new Api();
export function getPlans(options) {
  getPlansApi.cancelPendingRequest();

  let params = {
    params: options,
    cancelToken: getPlansApi.giveCancelToken()
  }

  return dispatch => {
    dispatch(getPlansRequest());
    return getPlansApi.get("/__api/v1/plans", params)
    .then(response => {
      dispatch(getPlansSuccess(response.data, options.is_template))
    })
    .catch(err => dispatch(getPlansFailure(err)));
  }
}

export function loadPlan(options) {
  let params = {
    params: {
      include_hidden_risks: options.include_hidden_risks,
      page: options.page,
      search_term: options.search_term,
      sort_by: options.sort_by,
      column_name: options.column_name,
      filter_by_tags: options.filter_by_tags,
      is_control_report: options.is_control_report,
      control_tags: options.control_tags,
      language: options.language,
      risk_tags_filter: options.risk_tags_filter,
      control_tags_filter: options.control_tags_filter,
      lib_control_tags_filter: options.lib_control_tags_filter,
      lib_control_admins_filter: options.lib_control_admins_filter,
      business_area_filter: options.business_area_filter
    }
  }
  return dispatch => {
    dispatch(loadPlanRequest())
    const api = new Api();
    return api.get("/__api/v1/plan/" + options.plan_id, params)
    .then(response => {
      dispatch(loadPlanSuccess(response.data))
    })
    .catch(err => dispatch(loadPlanFailure(err)));
  }
}

export function openPlanPage(plan, is_new){
  if(is_new) {
    history.push({
      pathname: types.PLAN_ACTIVITIES_PATH.replace(':plan_id', plan.id),
      state: { plan: plan }
    })
  }
  else {
    history.push(types.LOAD_PLAN_PATH.replace(':plan_id', plan.id))
  }
}

export function exportPlanToExcel(options) {
  var params = {
    include_hidden_risks: options.include_hidden_risks,
    search_term: options.search_term,
    sort_by: options.sort_by,
    column_name: options.column_name,
    filter_by_tags: options.filter_by_tags,
    is_control_report: options.is_control_report,
    control_tags: options.control_tags,
    language: options.language,
    columns: options.columns,
    risk_tags_filter: options.risk_tags_filter,
    control_tags_filter: options.control_tags_filter,
    lib_control_tags_filter: options.lib_control_tags_filter,
    lib_control_admins_filter: options.lib_control_admins_filter
  }
  return dispatch => {
    dispatch(exportPlanToExcelRequest())
    const api = new Api();
    return api.get("/__api/v1/plan/"+ options.plan_id + "/export_plan_to_excel", {params: params, responseType: 'blob'})
    .then(response => {
      var exportData = {
        data: response.data,
        params: params,
      }
      dispatch(exportPlanToExcelSuccess(exportData))
    })
    .catch(err => dispatch(exportPlanToExcelFailure(err)));
  }
}

export function getComparisons(options) {
  let params = {
    params: {
      page: options.page,
      risk_ids: options.risk_ids,
      plan_ids: options.plan_ids,
      template_id: options.template_id
    }
  }
  return dispatch => {
    dispatch(getComparisonsRequest());
    const api = new Api();
    return api.get("/__api/v1/get_comparisons", params)
    .then(response => {
      dispatch(getComparisonsSuccess(response.data))
    })
    .catch(err => dispatch(getComparisonsFailure(err)));
  }
}

export function getProfile(plan_id) {
  let params = {}
  return dispatch => {
    dispatch(getProfileRequest());
    const api = new Api();
    return api.get("/__api/v1/plan/"+ plan_id +"/get_profiles", params)
    .then(response => {
      dispatch(getProfileSuccess(response.data))
    })
    .catch(err => dispatch(getProfileFailure(err)));
  }
}

export function saveAsNewPlan(params) {
  return dispatch => {
    dispatch(createNewPlanRequest())
    const api = new Api();
    return api.createNewPlan("/__api/v1/plan/" + params.plan_id + "/clone_plan", params)
    .then(response => {})
    .catch(err => dispatch(createNewPlanFailure(err)));
  }
}

export function getTree(plan_id, view_type) {
  let params = {
    params: {
      view_type: view_type
    }
  }
  return dispatch => {
    dispatch(getTreeRequest())
    const api = new Api();
    return api.get("/__api/v1/plan/" + plan_id + "/get_risks_tree", params)
    .then(response => {
      dispatch(getTreeSuccess(response.data))
    })
    .catch(err => dispatch(getTreeFailure(err)));
  }
}

export function getPlanTags() {
  return(dispatch) => {
    dispatch(getPlanTagsRequest())
    const api = new Api();
    return api.get("/__api/v1/plan_tags", null)
    .then(response => {
      Promise.all([
        dispatch(getPlanTagsSuccess(response.data))
      ]);
    })
    .catch(err => dispatch(getPlanTagsFailure(err)));
  }
}

export function exportPlansRequest(){
  return {
    type: types.EXPORT_PLANS_REQUEST,
  }
}

export function exportPlansSuccess(body){
  return {
    type: types.EXPORT_PLANS_SUCCESS,
    body: body
  }
}

export function exportPlansFailure(exception){
  return {
    type: types.EXPORT_PLANS_FAILURE,
    exception: exception
  }
}

export function exportPlans(options) {
  var params = {...options}
  return dispatch => {
    dispatch(exportPlansRequest())
    const api = new Api();
    return api.get("/__api/v1/plans/export_selected_plans", {params: params})
    .then(response => {
      dispatch(exportPlansSuccess(response.data))
    })
    .catch(err => dispatch(exportPlansFailure(err)));
  }
}

export function uploadPlanToInterpreter(plan_id) {
  return dispatch => {
    const api = new Api();
    return api.post("/__api/v1/plans/" + plan_id + "/upload_file", { plan_id })
    .then(() => dispatch({ type: types.PLAN_UPLOAD_STATUS, status: "uploading"}))
    .catch(() => dispatch({ type: types.PLAN_UPLOAD_STATUS, status: "upload_failed"}));
  }
}

export function updateUploadPlanStatus(status, details) {
  console.log(status, details)
  return dispatch => dispatch({ type: types.PLAN_UPLOAD_STATUS, status, details})
}



// WEBPACK FOOTER //
// ./src/actions/plan.js